/**
 * Shape of the consumer-initiated control frames (`subscribe` / `unsubscribe`) that both the live
 * and shadow sockets need to recognise so they can track active subscriptions and replay them
 * after a re-authorization.
 */
export interface ControlMessage {
    action?: string;
    sessionGroupId?: string;
    sessionId?: string;
}

/**
 * Identity of the subscription a control frame refers to.
 *
 * Mirrors the backend's own addressing: a subscription is registered under `sessionGroupId` when
 * present, so keying on it means an `unsubscribe` retires exactly the `subscribe` it cancels.
 */
export function subscriptionKey(message: ControlMessage | null | undefined): string | undefined {
    return message?.sessionGroupId ?? message?.sessionId;
}
